export class BlockAssigning {
	IsAssigningBlocked: boolean;
}
